module.exports = __webpack_public_path__ + "img/social.03f7734c.png";